var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DiagramBlock',{attrs:{"title":"Members","emptyDesc":"There is no members statistics data available yet","diagramItems":_vm.statistic,"loading":_vm.loading},on:{"details":_vm.clickToDetails,"legendClick":_vm.legendClick,"chartClick":_vm.chartClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }